export default {
      id: "round-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#round",
      toString: function () {
        return this.url;
      }
    }